module.exports = __webpack_public_path__ + "media/event-access/conference@3x-7fe38803.png";